import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import FileUpload from "./FileUpload";
import { toast } from "sonner";
import { Save } from "lucide-react";

const inputCls = "w-full bg-transparent border-b border-black/15 focus:border-[#0060A7] outline-none py-2";

export default function AdminCompanyProfile() {
    const [data, setData] = useState({
        pdf_path: "", pdf_path_ar: "", pdf_path_en: "",
        pdf_filename: "", pdf_filename_ar: "", pdf_filename_en: "",
        button_label_ar: "الملف التعريفي", button_label_en: "Company Profile",
        published: true,
    });

    useEffect(() => {
        api.get("/company-profile").then((r) => setData({
            pdf_path: r.data.pdf_path || "",
            pdf_path_ar: r.data.pdf_path_ar || r.data.pdf_path || "",
            pdf_path_en: r.data.pdf_path_en || r.data.pdf_path || "",
            pdf_filename: r.data.pdf_filename || "",
            pdf_filename_ar: r.data.pdf_filename_ar || r.data.pdf_filename || "",
            pdf_filename_en: r.data.pdf_filename_en || r.data.pdf_filename || "",
            button_label_ar: r.data.button_label_ar || "الملف التعريفي",
            button_label_en: r.data.button_label_en || "Company Profile",
            published: r.data.published !== false,
        })).catch(() => {});
    }, []);

    const handleFileUploadAr = (uploadData) => {
        if (typeof uploadData === 'object' && uploadData.id) {
            setData((current) => ({
                ...current,
                pdf_path_ar: uploadData.id,
                pdf_filename_ar: uploadData.filename || current.pdf_filename_ar,
            }));
        } else {
            // Manual URL entry or clearing
            setData((current) => ({ ...current, pdf_path_ar: uploadData }));
        }
    };

    const handleFileUploadEn = (uploadData) => {
        if (typeof uploadData === 'object' && uploadData.id) {
            setData((current) => ({
                ...current,
                pdf_path_en: uploadData.id,
                pdf_filename_en: uploadData.filename || current.pdf_filename_en,
            }));
        } else {
            // Manual URL entry or clearing
            setData((current) => ({ ...current, pdf_path_en: uploadData }));
        }
    };

    const save = async () => {
        try {
            const payload = {
                ...data,
                pdf_path: data.pdf_path_en || data.pdf_path_ar || "",
                pdf_filename: data.pdf_filename_en || data.pdf_filename_ar || "",
            };
            await api.put("/admin/company-profile", payload);
            toast.success("Saved");
        } catch (e) { toast.error(formatApiError(e)); }
    };

    return (
        <div data-testid="admin-profile-page" className="mx-auto w-full max-w-5xl pb-10">
            <h1 className="heading mb-2 text-2xl font-bold tracking-tight sm:text-3xl">Company Profile PDF</h1>
            <p className="text-sm text-[#6B7280] mb-6">إدارة ملف الشركة PDF الذي يظهر زرّ تحميله في البنر الرئيسي وصفحة التواصل.</p>

            <div className="space-y-6 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-black/5 sm:p-6 lg:p-8">
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                    <FileUpload value={data.pdf_path_ar} filename={data.pdf_filename_ar} onChange={handleFileUploadAr} accept="application/pdf" label="Arabic profile PDF" testid="profile-pdf-upload-ar" returnFilename={true} />
                    <FileUpload value={data.pdf_path_en} filename={data.pdf_filename_en} onChange={handleFileUploadEn} accept="application/pdf" label="English profile PDF" testid="profile-pdf-upload-en" returnFilename={true} />
                </div>

                <div className="grid grid-cols-1 gap-6 border-t border-black/10 pt-6 md:grid-cols-2">
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Download button label (AR)</label>
                        <input data-testid="profile-label-ar" className={inputCls} value={data.button_label_ar} onChange={(e) => setData({ ...data, button_label_ar: e.target.value })} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Download button label (EN)</label>
                        <input data-testid="profile-label-en" className={inputCls} value={data.button_label_en} onChange={(e) => setData({ ...data, button_label_en: e.target.value })} />
                    </div>
                </div>

                <label className="flex items-center gap-3 rounded-xl border border-black/10 bg-[#F8FAFC] p-4 text-sm">
                    <input type="checkbox" checked={data.published} onChange={(e) => setData({ ...data, published: e.target.checked })} data-testid="profile-published" />
                    Show download button on site
                </label>

            </div>

            <button onClick={save} data-testid="profile-save" className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#002951] px-8 py-3.5 text-sm font-semibold text-white hover:bg-[#0060A7] sm:w-auto">
                <Save size={16} /> Save changes
            </button>
        </div>
    );
}
